import responseHandler from "app/manage/software-repository/utils/responseHandler";
import API from "common-ui-components/components/utils/API";

const MessagesAPI = {
    getMessage : async (url, payload = {}, method = "GET",) => {
        if(!url) return;
        try {
            const response = await API[method.toLowerCase()](url, payload);
            const formattedResponse = responseHandler(response);
            if(!formattedResponse.ok) throw formattedResponse;
            return formattedResponse.body;
        } catch (error) {
            console.error(error.message);
        }
    }
}

export default MessagesAPI;